import React, {Fragment} from 'react';
import RouletteContent from '../../components/account/RouletteContent';

const Roulette = () => {
    return (
        <Fragment>       
            <div className="title_wrap">
                <div className="title_box">
                    <div className="title">룰렛</div>
                </div>
            </div>
            <RouletteContent />
        </Fragment>
    );
};

export default Roulette;


// WEBPACK FOOTER //
// ./src/containers/Account/Roulette.js